import { render, staticRenderFns } from "./WillSummary.vue?vue&type=template&id=6258f16e"
import script from "./WillSummary.vue?vue&type=script&lang=js"
export * from "./WillSummary.vue?vue&type=script&lang=js"
import style0 from "./WillSummary.vue?vue&type=style&index=0&id=6258f16e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports